export function isChineseCharacter(character: string) {
  return character.match(/[\u3400-\u9FFF]/) !== null
}

export function isValidPaymentName(name: string) {
  return /^[\p{L}\p{M} '.-]+$/u.test(name)
}

export function isValidBankName(name: string) {
  return /^[\p{L}\p{M}\p{N} (),./:-]+$/u.test(name)
}
